module.exports = __webpack_public_path__ + "static/media/feed-share.08457c06.svg";